import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ContactPreferenceDetails } from '../../Models/Models/Customer/ContactPreferenceDetails';

declare var IS_RUNNING_IN_APP_POOL;

export class ContactPreferenceDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<ContactPreferenceDetails, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ContactPreferenceDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<ContactPreferenceDetails, any>(url, data);
  }
  public put(customerId: number, preferenceDetails: ContactPreferenceDetails): Promise<ContactPreferenceDetails, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ContactPreferenceDetail/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, preferenceDetails: preferenceDetails }

    return AjaxWrapper.put<ContactPreferenceDetails, any>(url, data);
  }
}

